import React, { useState } from "react";

import { Tabs, Tab, Row, Col } from "react-bootstrap";
import Summary from "./Summary";
import Trades from "./Trades";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const BotPerformance = (props) => {
  const {t} = useTranslation()
  const newBot = useSelector((state) => state.createBot.newBot);
  const baseCoin = newBot.baseCoin;
  const quoteCoin = newBot.quoteCoin;
  const strategy = newBot.strategy;
  const lowerCaseStrategy = (strategy && strategy.toLowerCase()) || "long";
  const [activeTab, setActiveTab] = useState(0);
  const tabTitles = [t("summary"), t("trades")];
  const tabHeaders = tabTitles.map((item, index) => {
    return (
        <li className="skltbs-tab-item" key={index}>
        <button className={(index == activeTab ? "skltbs-tab skltbs-active" : "skltbs-tab" )} onClick={() => setActiveTab(index)}>{item}</button>
        </li>
    );
  });
  const tabs = [
    <Summary baseCoin={ quoteCoin} t={t}/>,
    <Trades
      baseCoin={quoteCoin || "USD"}
      quoteCoin={baseCoin || ""}
      isLong={lowerCaseStrategy == "long"}
      t={t}
    />,
  ];
  return (
    <div className="ba-summary-area">
    <div className="bot-detail-table-area">
        <ul className="skltbs-tab-group">
          {tabHeaders}
          </ul>
    </div>
    <div className="mt-4">{tabs[activeTab]}</div>
    
    </div>
   
  );
};

export default BotPerformance;
